<template>
    <Summarize/>
</template>

<script>
    import Summarize from '@/components/Summarize'

    export default {
        name: 'summarize',
        components: {
            Summarize
        },
        mounted() {
            // setTimeout(()=> {
            this.$eventHub.$emit('filter-data-visible', false)
            // },200)
        },
        methods: {}
    }
</script>
<style>

</style>
